export const EXLY_CREATOR_DOMAIN_REGEX = RegExp(
    `^[a-zA-Z0-9]+.${process.env.NEXT_PUBLIC_PROJECT_DOMAIN}`,
    "i"
);

export const EXLY_CREATOR_CUSTOM_DOMAIN_REGEX =
    /^(\w+\.)?([a-zA-Z0-9]+).(\w+)/i;
